import React from 'react';
import './style.scss';
import { UnitInput, UnitInputPosition } from '../unitInput';
import { UnitSelectorPosition } from '../unitSelector';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { InputTemplate, InputTemplateDataProps } from '../inputTemplate';
import { CheckInput, CheckInputDataProps } from '../checkInput';
import { UnitSelector } from '../unitSelector';
import { CommonData } from '../common';
import { SelectorDataProps } from '../selector';
import { AddressInfo, useAddressInput } from './hook';

//都道府県のあれこれ
//リスト名
enum Prefecture {
  HOKKAIDO = '北海道',
  AOMORI = '青森県',
  IWATE = '岩手県',
  MIYAGI = '宮城県',
  AKITA = '秋田県',
  YAMAGATA = '山形県',
  FUKUSHIMA = '福島県',
  IBARAKI = '茨城県',
  TOCHIGI = '栃木県',
  GUNMA = '群馬県',
  SAITAMA = '埼玉県',
  CHIBA = '千葉県',
  TOKYO = '東京都',
  KANAGAWA = '神奈川県',
  NIIGATA = '新潟県',
  TOYAMA = '富山県',
  ISHIKAWA = '石川県',
  FUKUI = '福井県',
  YAMANASHI = '山梨県',
  NAGANO = '長野県',
  GIFU = '岐阜県',
  SHIZUOKA = '静岡県',
  AICHI = '愛知県',
  MIE = '三重県',
  SHIGA = '滋賀県',
  KYOTO = '京都府',
  OSAKA = '大阪府',
  HYOGO = '兵庫県',
  NARA = '奈良県',
  WAKAYAMA = '和歌山県',
  TOTTORI = '鳥取県',
  SHIMANE = '島根県',
  OKAYAMA = '岡山県',
  HIROSHIMA = '広島県',
  YAMAGUCHI = '山口県',
  TOKUSHIMA = '徳島県',
  KAGAWA = '香川県',
  EHIME = '愛媛県',
  KOCHI = '高知県',
  FUKUOKA = '福岡県',
  SAGA = '佐賀県',
  NAGASAKI = '長崎県',
  KUMAMOTO = '熊本県',
  OITA = '大分県',
  MIYAZAKI = '宮崎県',
  KAGOSHIMA = '鹿児島県',
  OKINAWA = '沖縄県',
}

//{ id: number; value: string }[]のデータ作る
const PrefectureList: CommonData[] = (Object.keys(Prefecture) as (keyof typeof Prefecture)[]).map((key, index) => {
  return { id: index + 1, value: Prefecture[key] };
});
//string[]のデータ作る
const PrefectureStrs = PrefectureList.map((data) => data.value);

export type AddressInputType = {
  name: string;
} & AddressInputDataType;

export type AddressInputDataType = {
  postCode: InputTemplateDataProps;
  prefecture: SelectorDataProps;
  municipality: InputTemplateDataProps;
  streetAddress: InputTemplateDataProps;
  hasNoTownStreetAddress: CheckInputDataProps;
  buildingNameAndRoomNumber: InputTemplateDataProps;
  onSearchAddress: (addressInfo: AddressInfo) => void;
};

export const AddressInput = (props: AddressInputType) => {
  const { searchAddress } = useAddressInput(props.postCode.value, props.onSearchAddress);
  return (
    <>
      <div className="addressInput">
        <div className="addressInput_wrapper">
          <div className={`addressInput_wrapper_label`}>郵便番号</div>
          <div className={`addressInput_wrapper_inputColumn`}>
            <InputTemplate {...props.postCode} placeholder={'例：1007029（ハイフンは不要です）'} maxLength={7} />
            <Button
              label="郵便番号から住所を検索"
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.small}
              onClick={searchAddress}
            />
          </div>
        </div>

        <UnitSelector
          {...props.prefecture}
          label="都道府県"
          unit={UnitSelectorPosition.before}
          options={PrefectureStrs}
        />
        <UnitInput
          {...props.municipality}
          label="市区郡"
          unit={UnitInputPosition.before}
          type="text"
          placeholder="例：千代田区"
        />
        <div className="addressInput_wrapper">
          <div className={`addressInput_wrapper_label`}>町名・番地</div>
          <div className={`addressInput_wrapper_inputColumn`}>
            <InputTemplate
              {...props.streetAddress}
              type="text"
              placeholder={props.hasNoTownStreetAddress.checked ? '' : '例：丸の内2丁目7番2号'}
            />
            <div className="addressInput_wrapper_check">
              <CheckInput name={props.name} {...props.hasNoTownStreetAddress} label="番地なし" />
            </div>
          </div>
        </div>
        <UnitInput
          {...props.buildingNameAndRoomNumber}
          label="建物名・部屋番号"
          unit={UnitInputPosition.before}
          type="text"
          placeholder="例：JPタワー29階"
        />
      </div>
    </>
  );
};
